export const JSON_API_ERROR_RESPONSE = 'JsonApiErrorResponse';
export interface JsonApiErrorResponse {
  name: string;
  /** need to notify user default is true */
  notify: boolean;
  /** http status */
  status: number;
  errors: JsonApiError[];

  /** meta.StackTrace iff .net environment is 'Development' or 'Staging' */
  stackTrace?: string;
}

export interface JsonApiError {
  id?: string;
  title?: string;
  detail?: string;
  status?: number;
  code?: string;
  source?: {
    pointer?: string;
    parameter?: string;
  };
  meta?: Record<string, any>;
}

export interface ErrorWarningModel {
  message: string;
  severity: 'error' | 'warning';
  category: 'internal-error' | 'new-transaction-error' | 'rating-message';
  /** path to the error (rating messages only) */
  context?: string[];
  onClick?: () => void;
}

export class ClosePolicyError extends Error {
  constructor(message: string) {
    super(message);
    this.name = new.target.name;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
